export default "<div ui-view='header'></div>\n<div ui-view='content'></div>\n<div ui-view='footer'></div>"